// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import useMergeProps from '../../hooks/useMergeProps';
import { SportIds } from '../../types/sports';

import EventCenterNode from './EventCenterNode';
import selectEventCenterNodeProps from './EventCenterNode.selector';

const widgetHeightBySportId = {
  [SportIds.GOLF]: Target.__MOBILE__ ? 315 : 350,
  [SportIds.MMA]: Target.__MOBILE__ ? 315 : 325,
};

const StyledEventCenterNode = styled(EventCenterNode)`
  ${({ $sportId }) => css`
    height: ${widgetHeightBySportId[$sportId]}px;
  `}
`;

type EventCenterNodeContainerProps = {
  className?: string;
  matchId?: number;
  sportId?: number;
  categoryId?: number;
};

const EventCenterNodeContainer = ({ sportId, categoryId, matchId, ...ownProps }: EventCenterNodeContainerProps) => {
  const selectorProps = useMemo(() => ({ sportId, categoryId, matchId }), [sportId, categoryId, matchId]);
  const selectedProps = useSelector((state) => selectEventCenterNodeProps(state, selectorProps));
  const { config } = selectedProps;

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return config ? <StyledEventCenterNode {...enhancedProps} $sportId={sportId} /> : null;
};

export default EventCenterNodeContainer;
